import { type PrimeReactPTOptions } from "primereact/api";
import { type SelectButtonPassThroughMethodOptions } from "primereact/selectbutton";
import { classNames } from "primereact/utils";

export const selectbutton: PrimeReactPTOptions["selectbutton"] = {
  root: ({ props }: SelectButtonPassThroughMethodOptions) => ({
    className: classNames({
      "opacity-60 select-none pointer-events-none cursor-default": props.disabled,
    }),
  }),
  button: ({ context }: SelectButtonPassThroughMethodOptions) => ({
    className: classNames(
      "inline-flex cursor-pointer select-none items-center align-bottom text-center overflow-hidden relative",
      "p-1 px-3",
      "stroke-gray-200 text-gray-200",
      "transition duration-200 border border-r-0 borde-[#E3E3E3]",
      "first:rounded-l-md first:rounded-tr-none first:rounded-br-none last:border-r last:rounded-tl-none last:rounded-bl-none last:rounded-r-md",
      "focus:outline-none focus:outline-offset-0",
      {
        "bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 hover:bg-gray-50 dark:hover:bg-gray-800/80 ":
          !context.selected,
        "bg-rdc-primaryLight text-rdc-primary": context.selected,
        "opacity-60 select-none pointer-events-none cursor-default": context.disabled,
      },
    ),
  }),
  label: ["font-bold"],
};
